import configAr from './checkConfig'
class CheckCentralControl {
    //获取配置函数
    getCheckConfig(str) {
        return configAr[str];
    }

}
let checkCentralControl = new CheckCentralControl();
export default checkCentralControl;